type TdsModalHelpProps = {
  claimHeader: string
  children: React.ReactNode
  pageName: string
}

const TdsModalHelp = ({ claimHeader, children, pageName }: TdsModalHelpProps) => (
  <div
    role="dialog"
    data-backdrop-close="false"
    className="tds-modal tds-modal__dialog--medium"
    id={pageName}
    hidden
  >
    <div
      role="document"
      className="tds-modal__dialog-container"
      aria-labelledby="help-modal-heading-md"
      aria-describedby="help-modal-description-md"
    >
      <div className="tds-modal__dialog-header">
        <h2 className="tds-modal__dialog-title" id="help-modal-heading-md">
          { claimHeader }
        </h2>
      </div>
        <div className="tds-modal__dialog-body">
        <div className="tds-modal__dialog-body-content" id="help-modal-description-md">
          { children }
        </div>
      </div>
      <button className="tds-modal__dismiss" aria-label="Dismiss dialog" type="button">
        <svg focusable="false">
          <use xlinkHref="/claimuploadcenter/icons/symbol-sprites.svg#x-1-12" />
        </svg>
      </button>
    </div>
  </div>
)

export { TdsModalHelp }
